import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { id: "select-input" }
const _hoisted_2 = { class: "form-group search-type-and-or input-standard-size" }
const _hoisted_3 = {
  key: 0,
  class: /*@__PURE__*/_normalizeClass({'col-form-label':true,'highlight':true})
}
const _hoisted_4 = {
  key: 1,
  class: "col-form-label"
}
const _hoisted_5 = {
  key: 2,
  class: "search-type-and-or input-standard-size"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_b_form_radio_group = _resolveComponent("b-form-radio-group")!
  const _component_b_form_select = _resolveComponent("b-form-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("fieldset", _hoisted_2, [
      (_ctx.label && _ctx.error)
        ? (_openBlock(), _createElementBlock("legend", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
            _cache[1] || (_cache[1] = _createElementVNode("span", null, " * ", -1)),
            _createVNode(_component_font_awesome_icon, {
              id: "fieldError",
              icon: "fa-solid fa-info-circle"
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.label && !_ctx.error)
        ? (_openBlock(), _createElementBlock("legend", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
            (_ctx.moreInfo)
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 0,
                  icon: "fa-solid fa-info-circle",
                  "popover.hover.top": "moreInfo"
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.radioLabel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_b_form_radio_group, {
              options: _ctx.radioOptions,
              modelValue: _ctx.and,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.and) = $event)),
              onInput: _ctx.handleRadioChange
            }, null, 8, ["options", "modelValue", "onInput"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.noOptionsText && _ctx.isEmpty())
        ? (_openBlock(), _createElementBlock("span", {
            key: 3,
            class: "empty",
            style: _normalizeStyle({fontSize: `${_ctx.fontSize}px`})
          }, _toDisplayString(_ctx.noOptionsText), 5))
        : _createCommentVNode("", true),
      _createVNode(_component_b_form_select, {
        class: "limit-inline-display",
        style: _normalizeStyle({fontSize: `${_ctx.fontSize}px`}),
        modelValue: _ctx.componentModel,
        options: _ctx.componentOptions,
        onChange: _ctx.emitChange,
        disabled: _ctx.disabled,
        readonly: _ctx.readonly,
        multiple: _ctx.multiple,
        required: _ctx.needsValue
      }, null, 8, ["style", "modelValue", "options", "onChange", "disabled", "readonly", "multiple", "required"])
    ])
  ]))
}